import type { ReactNode } from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import type { AnimVariant } from '../../hooks/useScrollAnimation';

interface Props {
  children: ReactNode;
  className?: string;
  delay?: number;
  variant?: AnimVariant;
}

export default function AnimatedSection({ children, className = '', delay = 0, variant = 'fadeUp' }: Props) {
  const { ref, animClass } = useScrollAnimation({ variant });
  return (
    <div
      ref={ref}
      className={`${animClass} ${className}`}
      style={delay > 0 ? { transitionDelay: `${delay}ms` } : undefined}
    >
      {children}
    </div>
  );
}
